import React from "react";
import {motion} from "motion/react";
import TapHereLabel from "@/components/TapHereLabel";
import {useNav} from "@/hooks/useNav";
import { useShortcuts } from "@/hooks/useShortcuts";

interface ScreenSaverLayerProps extends React.HTMLAttributes<HTMLDivElement> {
}

const ScreenSaverLayer: React.FC<ScreenSaverLayerProps> = ({
                                                               className,
                                                               ...props
                                                           }) => {
    const {currentSection, isTransitioning, navigateToSection} = useNav();

    useShortcuts({
        onEnter: () => navigateToSection("intro_text"),
        enabledSections: ['screensaver']
    });
    return (
        <div {...props} style={{width: "100vw", height: "100vh", padding: 100, zIndex: 6, position: 'absolute'}}>
            <motion.div
                animate={{
                    opacity: !isTransitioning && currentSection === "screensaver" ? 1 : 0,
                    pointerEvents:
                        !isTransitioning && currentSection === "screensaver"
                            ? "auto"
                            : "none",
                }}
                transition={{duration: 0.4, ease: "easeOut"}}
            >
                <TapHereLabel/>
            </motion.div>
            <button
                onClick={() => navigateToSection("intro_text")}
                style={{
                    position: "fixed",
                    inset: 0,
                    zIndex: 1,
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                }}
            ></button>
        </div>
    );
};

export default ScreenSaverLayer;
